import React, { useState, useEffect, useRef } from "react"; // Added useRef
import { db } from "./firebase";
import { ref, push, onValue, serverTimestamp } from "firebase/database";
import "./App.css";

function App() {
  const [username, setUsername] = useState("");
  const [roomID, setRoomID] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [msg, setMsg] = useState("");
  const [list, setList] = useState([]);

  // 1. Create a reference for the bottom of the chat
  const dummySpace = useRef(null);

  useEffect(() => {
    if (!isLoggedIn || !roomID) return;

    const messagesRef = ref(db, `groups/${roomID}`);
    const unsubscribe = onValue(messagesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadMessages = Object.keys(data).map((key) => ({
          ...data[key],
          id: key,
        }));
        setList(loadMessages);
      }
    });

    return () => unsubscribe();
  }, [isLoggedIn, roomID]);

  // 2. This effect triggers every time 'list' changes (new message)
  useEffect(() => {
    if (dummySpace.current) {
      dummySpace.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [list]);

  const send = (e) => {
    e.preventDefault();
    if (msg.trim() === "") return;
    const messagesRef = ref(db, `groups/${roomID}`);
    push(messagesRef, {
      author: username,
      message: msg,
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      timestamp: serverTimestamp(),
    });
    setMsg("");
  };

  if (!isLoggedIn) {
    return (
      <div className="app-viewport">
        <div className="login-card animate-pop">
          <div className="brand-header">
            <div className="logo-icon">N</div>
            <h1>NEBULA</h1>
            <p>Secure Real-time Messaging</p>
          </div>

          <div className="input-group">
            <label>Display Name</label>
            <input
              type="text"
              placeholder="e.g. Lily"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="input-group">
            <label>Group ID</label>
            <input
              type="text"
              placeholder="e.g. project alpha"
              value={roomID}
              onChange={(e) => setRoomID(e.target.value)} // Removed .trim() and .toLowerCase() from here
            />
          </div>

          <button
            className={`action-btn join-btn ${
              username && roomID ? "ready" : "locked"
            }`}
            onClick={() => {
              if (username && roomID) {
                // Apply the cleaning ONLY when clicking the button
                const cleanRoomID = roomID
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, "-");
                setRoomID(cleanRoomID);
                setIsLoggedIn(true);
              }
            }}
          >
            <span>Join Group</span>
            <div className="btn-glow"></div>
          </button>

          <div className="login-footer">Connected to Secure Cloud Hub</div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-viewport">
      <div className="chat-window">
        <header className="chat-header">
          <div className="header-info">
            <span className="dot"></span>
            <p>
              Group: <b>{roomID}</b> | User: <b>{username}</b>
            </p>
          </div>
          <button className="exit-btn" onClick={() => window.location.reload()}>
            Leave
          </button>
        </header>

        <div className="message-container">
          {list.map((m) => (
            <div
              key={m.id}
              className={`message-row ${
                m.author === username ? "sent" : "received"
              }`}
            >
              <div className="message-bubble">
                {m.author !== username && (
                  <span className="message-author">{m.author}</span>
                )}
                <p className="message-text">{m.message}</p>
                <span className="message-time">{m.time}</span>
              </div>
            </div>
          ))}
          {/* 3. Empty div to scroll to */}
          <div ref={dummySpace}></div>
        </div>

        <form className="message-input-area" onSubmit={send}>
          <input
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            placeholder="Type a message..."
          />
          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
}

export default App;
